export default function WhyUsSection() {
  const advantages = [
    {
      icon: 'ri-award-line',
      title: '行业权威',
      desc: '深耕喷水系统领域十余年，汇聚行业顶尖专家和技术资源，提供最权威的喷水方案指导。'
    },
    {
      icon: 'ri-team-line',
      title: '专业团队',
      desc: '拥有农业灌溉、景观设计和工业工程多领域专家团队，为您量身定制最优喷水方案。'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '全程服务',
      desc: '从方案咨询、设备选型到安装指导和售后维护，提供一站式喷水系统服务。'
    },
    {
      icon: 'ri-shield-check-line',
      title: '品质保障',
      desc: '推荐的所有喷水设备均通过严格质量检测，确保长期稳定运行，让您无后顾之忧。'
    }
  ];

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50" aria-labelledby="why-us-title">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 id="why-us-title" className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            为什么选择我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            专业、可靠、高效，致力于成为您最信赖的喷水系统合作伙伴
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {advantages.map((item, index) => (
            <div key={index} className="text-center p-6 rounded-lg bg-background-100/80 border border-background-200/70">
              <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center">
                <i className={`${item.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}